import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

// ============================================
// IMPORT YOUR BRIDGE IMAGES HERE ⬇️
// ============================================
import bridge1 from '../assets/images/bridge1.jpg';
import bridge2 from '../assets/images/bridge2.jpg';
import bridge3 from '../assets/images/bridge3.jpg';
import descImage from '../assets/images/bridgedesc.jpg';

import '../styles/Pages.css';

const Bridges = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const featuredImages = [bridge1, bridge2, bridge3];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Bridges</h1>
            <p>Advanced Bridge Infrastructure Solutions</p>
          </div>
        </div>
      </section>

      {/* FEATURED IMAGES - 3 IMAGES */}
      <section style={{ padding: '60px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px' }}>
            {featuredImages.map((img, index) => (
              <div 
                key={index}
                style={{ 
                  overflow: 'hidden', 
                  borderRadius: '8px', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.12)', 
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  aspectRatio: '4/3'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
                }}
              >
                <img 
                  src={img} 
                  alt={`Bridge ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROJECT DETAILS */}
      <section style={{ padding: '60px 20px', background: '#f9f9f9', borderTop: '1px solid #e0e0e0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(5, 1fr)', 
            gap: '30px',
            textAlign: 'center'
          }}>
            <div>
              <p style={{ fontSize: '14px', color: '#999', marginBottom: '10px', fontWeight: '500' }}>Company</p>
              <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', margin: '0' }}>Max Infra</h3>
            </div>
            <div>
              <p style={{ fontSize: '14px', color: '#999', marginBottom: '10px', fontWeight: '500' }}>Category</p>
              <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', margin: '0' }}>Bridge Construction</h3>
            </div>
            <div>
              <p style={{ fontSize: '14px', color: '#999', marginBottom: '10px', fontWeight: '500' }}>Start Time</p>
              <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', margin: '0' }}>2023</h3>
            </div>
            <div>
              <p style={{ fontSize: '14px', color: '#999', marginBottom: '10px', fontWeight: '500' }}>Delivery</p>
              <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', margin: '0' }}>On Time</h3>
            </div>
            <div>
              <p style={{ fontSize: '14px', color: '#999', marginBottom: '10px', fontWeight: '500' }}>Feedback</p>
              <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', margin: '0' }}>Excellent</h3>
            </div>
          </div>
        </div>
      </section>

      {/* PROJECT DESCRIPTION - TEXT LEFT + IMAGE RIGHT */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'center' }}>
          
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '20px' }}>
              Project Description
            </h2>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              Max Infra has successfully completed several prestigious bridge construction projects across India. Our expertise spans highway bridges, railway bridges, and critical infrastructure spanning challenging terrains. With advanced engineering techniques and state-of-the-art machinery, we deliver world-class bridge infrastructure solutions.
            </p>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', textAlign: 'justify' }}>
              Each bridge project showcases our commitment to quality, safety, and on-time delivery. Our skilled workforce and proven track record in complex bridge construction make us a trusted partner for critical infrastructure development across the nation.
            </p>
          </div>

          <div style={{ 
            overflow: 'hidden', 
            borderRadius: '8px', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            aspectRatio: '4/3'
          }}>
            <img 
              src={descImage} 
              alt="Bridge Project"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </div>
      </section>

      {/* PROCESS & FINALIZE SECTION */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px' }}>
          
          {/* LEFT - PROCESS */}
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '50px' }}>
              Following Process
            </h2>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
              {[
                { title: 'Site Inspection', desc: 'Comprehensive survey and analysis of the bridge location' },
                { title: 'Design Planning', desc: 'Advanced engineering design and structural planning' },
                { title: 'Construction', desc: 'Execution with modern machinery and skilled workforce' },
                { title: 'Quality Check', desc: 'Rigorous testing and quality assurance protocols' }
              ].map((step, index) => (
                <div key={index} style={{ 
                  background: '#fff', 
                  padding: '30px', 
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  textAlign: 'center'
                }}>
                  <div style={{ 
                    width: '60px', 
                    height: '60px', 
                    background: '#ff6b35', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    color: '#fff',
                    fontSize: '24px',
                    fontWeight: 'bold'
                  }}>
                    {index + 1}
                  </div>
                  <h3 style={{ fontSize: '18px', color: '#0066cc', fontWeight: 'bold', marginBottom: '10px' }}>
                    {step.title}
                  </h3>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                    {step.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT - FINALIZE */}
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '30px' }}>
              Finalize the Project
            </h2>

            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              Upon completion, all bridge structures undergo comprehensive testing including load testing, durability checks, and safety verification. We ensure every bridge meets international standards and provides safe passage for decades.
            </p>

            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '30px', textAlign: 'justify' }}>
              Our commitment extends beyond project completion with dedicated maintenance and support services to ensure optimal performance of the infrastructure throughout its lifecycle.
            </p>

            <div style={{ 
              overflow: 'hidden', 
              borderRadius: '8px', 
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              aspectRatio: '16/9'
            }}>
              <img 
                src={descImage} 
                alt="Finalize Bridge"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE */}
      <style>{`
        @media (max-width: 1024px) {
          .bridge-grid {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          .process-grid {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 768px) {
          .bridge-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Bridges;